import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { API, UPLOADS } from "./../../config/api"; // ✅ Import API

export default function AddDesigner() {
  const user = JSON.parse(sessionStorage.getItem("user"));
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    experience: "",
    experience_year: "",
    experience_month: "",
    skills: [],
    location: "",
    expected_salary: "",
    description: "",
    profile: null,
  });
  const [errors, setErrors] = useState({
    phone: "",
    profile: "",
  });
  const skillList = ["Malti", "Sequien", "Cording", "Beads", "Chain"];

  /* =========================
HANDLE INPUT
========================= */

  const handleChange = (e) => {
    const { name, value, type } = e.target;

    // 📱 Phone Validation
    if (name === "phone") {
      if (!/^[0-9]{0,10}$/.test(value)) return;

      if (value.length < 10) {
        setErrors((prev) => ({
          ...prev,
          phone: "Phone must be 10 digits",
        }));
      } else {
        setErrors((prev) => ({
          ...prev,
          phone: "",
        }));
      }

      setForm({ ...form, [name]: value });
      return;
    }

    // 🖼 Profile Image Validation
    if (type === "file") {
      const file = e.target.files[0];

      // ❗ Required check
      if (!file) {
        setErrors((prev) => ({
          ...prev,
          profile: "Profile image is required",
        }));
        return;
      }

      // ❗ File type validation
      if (!file.type.startsWith("image/")) {
        setErrors((prev) => ({
          ...prev,
          profile: "Only image files allowed",
        }));
        return;
      }

      // ❗ File size validation (2MB)
      if (file.size > 2 * 1024 * 1024) {
        setErrors((prev) => ({
          ...prev,
          profile: "Max 2MB allowed",
        }));
        return;
      }

      // ✅ Clear error if valid
      setErrors((prev) => ({
        ...prev,
        profile: "",
      }));

      // ✅ Set file
      setForm({ ...form, [name]: file });

      return;
    }

    setForm({ ...form, [name]: value });
  };

  const [designers, setDesigners] = useState([]);
  const [editData, setEditData] = useState(null);
  const [viewData, setViewData] = useState(null);
  const [loading, setLoading] = useState(false);

  // Get user session
  const savedUser = sessionStorage.getItem("user");

  useEffect(() => {
    if (user?.id) {
      fetchDesigners();
    }
  }, [user]);

  /* ================= FETCH ================= */
  const fetchDesigners = async () => {
    try {
      const res = await fetch(`${API.USER_DESIGNERS}&user_id=${user.id}`);
      const data = await res.json();
      setDesigners(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Fetch Error:", error);
    }
  };

  /* ================= UPDATE ================= */
  {
    /* =========================
UPDATE DESIGNER VALIDATION
========================= */
  }

  const handleUpdate = async (e) => {
    e.preventDefault();

    /* =========================
     PHONE VALIDATION
     - exactly 10 digits
  ========================= */

    if (!editData.phone || !/^[0-9]{10}$/.test(editData.phone)) {
      alert("Phone number must be exactly 10 digits");
      return;
    }

    /* =========================
     EXPERIENCE VALIDATION
     Allow:
     - only years
     - only months
     - both
     Not allow:
     - both empty
  ========================= */

    let expYears = editData.experience_year || "";
    let expMonths = editData.experience_month || "";

    // remove text if user types years/month manually
    expYears = expYears
      .toString()
      .replace(/years?|yrs?/gi, "")
      .trim();
    expMonths = expMonths
      .toString()
      .replace(/months?|mon/gi, "")
      .trim();

    // allow only numbers
    if (expYears && !/^\d+$/.test(expYears)) {
      alert("Experience Years must contain only numbers");
      return;
    }

    if (expMonths && !/^\d+$/.test(expMonths)) {
      alert("Experience Months must contain only numbers");
      return;
    }

    if (!expYears && !expMonths) {
      alert("Please enter Experience Years or Months");
      return;
    }

    /* =========================
     AUTO ADD YEARS / MONTHS
  ========================= */

    let finalExperience = "";

    if (expYears && expMonths) {
      finalExperience = `${expYears} Yrs / ${expMonths} Mon`;
    } else if (expYears) {
      finalExperience = `${expYears} Yrs`;
    } else if (expMonths) {
      finalExperience = `${expMonths} Mon`;
    }

    try {
      const formData = new FormData();

      formData.append("id", editData.id);
      formData.append("name", editData.name);
      formData.append("email", editData.email);
      formData.append("phone", editData.phone);

      // ✅ updated experience
      formData.append("experience", finalExperience);

      formData.append("skills", editData.skills);
      formData.append("location", editData.location);
      formData.append("expected_salary", editData.expected_salary);
      formData.append("description", editData.description);

      if (editData.profile instanceof File) {
        formData.append("profile", editData.profile);
      }

      setLoading(true);

      const res = await fetch(API.UPDATE_DESIGNERS, {
        method: "POST",
        body: formData,
      });

      const text = await res.text();
      console.log("Server Response:", text);

      const data = JSON.parse(text);

      setLoading(false);

      if (data.status) {
        alert("Designer Updated Successfully");
        setEditData(null);
        fetchDesigners();
      } else {
        alert(data.message || "Update Failed");
      }
    } catch (error) {
      console.error("Update Error:", error);
      setLoading(false);
      alert("Server Error");
    }
  };
  /* ================= DELETE ================= */
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this designer?")) return;

    const formData = new FormData();
    formData.append("id", id);

    await fetch(API.DELETE_DESIGNER, {
      method: "POST",
      body: formData,
    });

    fetchDesigners();
  };

  /* =========================
SKILLS
========================= */

  const handleSkillChange = (skill) => {
    setForm((prev) => {
      const isSelected = prev.skills.includes(skill);
      const updatedSkills = isSelected
        ? prev.skills.filter((s) => s !== skill)
        : [...prev.skills, skill];

      return { ...prev, skills: updatedSkills };
    });
  };

  /* =========================
SUBMIT
========================= */
  /* =========================
SUBMIT
========================= */

  const handleSubmit = async (e) => {
    e.preventDefault();

    /* =========================
     PHONE VALIDATION
  ========================= */

    if (!form.phone || form.phone.length !== 10) {
      alert("Phone number must be exactly 10 digits");
      return;
    }

    if (errors.phone) {
      alert("Please enter valid phone number");
      return;
    }

    /* =========================
     EXPERIENCE VALIDATION
     Allow:
     - Only Year
     - Only Month
     - Both Year + Month

     Not Allow:
     - Neither selected
  ========================= */

    const hasYear = !!form.experience_year;
    const hasMonth = !!form.experience_month;

    if (!hasYear && !hasMonth) {
      alert("Please select at least Years or Months in Experience");
      return;
    }

    /* =========================
     Rebuild Final Experience
  ========================= */

    let finalExperience = "";

    if (hasYear && hasMonth) {
      finalExperience = `${form.experience_year} Yrs / ${form.experience_month} Mon`;
    } else if (hasYear) {
      finalExperience = `${form.experience_year} Yrs`;
    } else if (hasMonth) {
      finalExperience = `${form.experience_month} Mon`;
    }

    /* =========================
     PROFILE VALIDATION
  ========================= */

    if (!form.profile) {
      setErrors((prev) => ({
        ...prev,
        profile: "Profile image is required",
      }));
      return;
    }

    /* =========================
     FORM DATA
  ========================= */

    const formData = new FormData();

    formData.append("user_id", user.id);
    formData.append("status", "pending");
    formData.append("name", form.name);
    formData.append("email", form.email);
    formData.append("phone", form.phone);

    // ✅ Use finalExperience here
    formData.append("experience", finalExperience);

    formData.append("skills", form.skills.join(", "));
    formData.append("location", form.location);
    formData.append("expected_salary", form.expected_salary);
    formData.append("profile", form.profile);
    formData.append("description", form.description);

    try {
      const res = await fetch(API.ADD_DESIGNER, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();

      if (data.status) {
        alert(data.message);

        fetchDesigners();

        // Reset form
        setForm({
          name: "",
          email: "",
          phone: "",
          experience: "",
          experience_year: "",
          experience_month: "",
          skills: [],
          location: "",
          expected_salary: "",
          description: "",
          profile: null,
        });

        // Reset errors
        setErrors({
          phone: "",
          profile: "",
        });

        // Clear file input manually
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      } else {
        alert(data.message || "Something went wrong");
      }
    } catch (error) {
      console.error("Submission error:", error);
      alert("Server error");
    }
  };

  return (
    <div className="dashboard-content designer-page">
      <form onSubmit={handleSubmit} className="designer-form">
        <div
          className="border-box"
          style={{
            border: "1px solid #495057 ",
            padding: "35px",
            boxShadow: "inset 0 0 0 1px #495057",
            borderRadius: "5px",
          }}
        >
          <h2 className="machine-title">Add Designer</h2>
          <div className="row g-3">
            {/* Name */}
            <div className="col-md-12">
              <label className="designer-label">Designer Name</label>
              <input
                type="text"
                name="name"
                className="designer-input"
                placeholder="Enter designer name"
                value={form.name}
                onChange={handleChange}
                required
              />
            </div>

            {/* Email */}
            <div className="col-md-12">
              <label className="designer-label">Email</label>
              <input
                type="email"
                name="email"
                className="designer-input"
                placeholder="Enter email"
                value={form.email}
                onChange={handleChange}
              />
            </div>

            {/* Photo */}
            <div className="col-md-12">
              <label className="designer-label">Profile Photo</label>
              <input
                type="file"
                name="profile"
                className="designer-input"
                onChange={handleChange}
                ref={fileInputRef}
              />

              {errors.profile && (
                <span className="error">{errors.profile}</span>
              )}
            </div>

            {/* Phone */}
            <div className="col-md-12">
              <label className="designer-label">Mobile No</label>
              <input
                type="text"
                name="phone"
                className="designer-input"
                placeholder="Enter phone number"
                value={form.phone}
                onChange={handleChange}
                required
              />

              {errors.phone && <span className="error">{errors.phone}</span>}
            </div>

            {/* Experience */}
            {/* Experience */}
            <div className="col-md-12">
              <label className="designer-label">Experience</label>

              <div className="d-flex gap-2">
                <input
                  type="text"
                  name="experience_year"
                  className="designer-input"
                  placeholder="Years"
                  value={form.experience_year}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");

                    setForm({
                      ...form,
                      experience_year: value,
                    });
                  }}
                />

                <input
                  type="text"
                  name="experience_month"
                  className="designer-input"
                  placeholder="Months"
                  value={form.experience_month}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");

                    setForm({
                      ...form,
                      experience_month: value,
                    });
                  }}
                />
              </div>
            </div>

            {/* Location */}
            <div className="col-md-12">
              <label className="designer-label">Location</label>
              <input
                type="text"
                name="location"
                className="designer-input"
                placeholder="Surat"
                value={form.location}
                onChange={handleChange}
              />
            </div>

            {/* Salary */}
            <div className="col-md-12">
              <label className="designer-label">Salary / Hour</label>
              <input
                type="number"
                name="expected_salary"
                className="designer-input"
                placeholder="700"
                value={form.expected_salary}
                onChange={handleChange}
                required
              />
            </div>

            {/* Skills */}
            <div className="col-md-12">
              <label className="designer-label">Expertise Skills</label>

              <div className="designer-skills">
                <div className="designer-skill-grid">
                  {skillList.map((skill) => (
                    <div key={skill} className="designer-skill-box">
                      <input
                        type="checkbox"
                        className="designer-checkbox"
                        checked={form.skills.includes(skill)}
                        onChange={() => handleSkillChange(skill)}
                      />

                      <span>{skill}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Description */}

            <div className="col-md-12">
              <label className="designer-label">About Work</label>

              <textarea
                name="description"
                className="designer-input designer-textarea"
                placeholder="Describe your work..."
                value={form.description}
                onChange={handleChange}
              ></textarea>
            </div>

            {/* Button */}

            <div className="col-12">
              <button type="submit" className="designer-btn">
                <i className="bi bi-person-plus-fill me-2"></i>
                Register Designer
              </button>
            </div>
          </div>
        </div>
      </form>

      {/* CARD GRID */}
      <div className="designs-grid">
        {designers.length > 0 ? (
          designers.map((item) => (
            <div className="design-card" key={item.id}>
              {/* IMAGE */}
              <div className="machine-img-container">
                <img
                  src={`${UPLOADS.DESIGNER_IMAGE}${item.profile}`}
                  alt={item.name}
                  onError={(e) =>
                    (e.target.src = "https://via.placeholder.com/300x250")
                  }
                />
              </div>

              {/* BODY */}
              <div className="machine-body">
                <h4 className="machine-name">{item.name}</h4>

                {/* PHONE */}
                <div className="d-flex align-items-center justify-content-between mt-2">
                  <div className="price-block">
                    <span className="currency-symbol">₹</span>
                    <span className="amount">
                      {Number(item.expected_salary).toLocaleString("en-IN")}
                    </span>
                  </div>

                  <button className="contact-btn">
                    <i className="bi bi-telephone-fill me-1"></i>
                    Contact
                  </button>
                </div>

                {/* SKILLS */}
                <div className="spec-row mt-2">
                  <div className="spec-item">
                    <span className="spec-label">Skills:</span>
                    <span className="spec-value">{item.skills}</span>
                  </div>

                  <div className="spec-item">
                    <span className="spec-label">Exp:</span>
                    <span className="spec-value">{item.experience}</span>
                  </div>
                </div>

                {/* LOCATION */}
                <div className="location-info">
                  <i className="bi bi-geo-alt-fill"></i>
                  {item.location}
                </div>

                {/* STATUS */}
                <div className="mt-2">
                  <span className={`status ${item.status?.toLowerCase()}`}>
                    {item.status}
                  </span>
                </div>

                {/* FOOTER BUTTONS */}
                <div className="machine-actions mt-3">
                  <button
                    className="action-btn view-action"
                    onClick={() => setViewData(item)}
                    title="View"
                  >
                    <i className="bi bi-eye-fill"></i>
                  </button>

                  <button
                    className="action-btn edit-action"
                    onClick={() => {
                      let years = "";
                      let months = "";

                      if (item.experience) {
                        // Example: "2 Years / 6 Months"
                        const yearMatch = item.experience.match(
                          /(\d+)\s*(Year|Years|Yrs)/i,
                        );
                        const monthMatch = item.experience.match(
                          /(\d+)\s*(Month|Months|Mon)/i,
                        );

                        years = yearMatch ? yearMatch[1] : "";
                        months = monthMatch ? monthMatch[1] : "";
                      }

                      setEditData({
                        ...item,
                        experience_year: years,
                        experience_month: months,
                      });
                    }}
                    title="Edit"
                  >
                    <i className="bi bi-pencil-square"></i>
                  </button>

                  <button
                    className="action-btn delete-action"
                    onClick={() => handleDelete(item.id)}
                    title="Delete"
                  >
                    <i className="bi bi-trash-fill"></i>
                  </button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p>No Designers Found</p>
        )}
      </div>

      {/* VIEW POPUP */}
      {viewData && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div className="popup-header">
              <h3>Designer Details</h3>

              <button
                className="close-icon-btn"
                onClick={() => setViewData(null)}
              >
                ✕
              </button>
            </div>

            <div className="text-center mb-3">
              <img
                src={`${UPLOADS.DESIGNER_IMAGE}${viewData.profile}`}
                style={{
                  width: "120px",
                  height: "120px",
                  objectFit: "cover",
                  borderRadius: "10px",
                }}
                alt="profile"
              />
            </div>

            <div className="popup-grid">
              <div>
                <label>Name</label>
                <p>{viewData.name}</p>
              </div>
              <div>
                <label>Email</label>
                <p>{viewData.email}</p>
              </div>
              <div>
                <label>Phone</label>
                <p>{viewData.phone}</p>
              </div>
              <div>
                <label>Experience</label>
                <p>{viewData.experience}</p>
              </div>
              <div>
                <label>Salary</label>
                <p>₹ {viewData.expected_salary}</p>
              </div>
              <div>
                <label>Skills</label>
                <p>{viewData.skills}</p>
              </div>
              <div>
                <label>Location</label>
                <p>{viewData.location}</p>
              </div>

              <div>
                <label>Date</label>
                <p>{viewData.created_at}</p>
              </div>
            </div>

            <div className="description-box">
              <label>Description</label>
              <p>{viewData.description}</p>
            </div>
          </div>
        </div>
      )}

      {/* EDIT POPUP */}
      {editData && (
        <div className="popup-overlay">
          <div className="popup-box large-popup">
            <div className="popup-header">
              <h3>Edit Designer</h3>

              <button
                className="close-icon-btn"
                onClick={() => setEditData(null)}
              >
                ✕
              </button>
            </div>

            <form onSubmit={handleUpdate}>
              <div className="popup-grid">
                <div>
                  <label>Name</label>
                  <input
                    type="text"
                    value={editData.name}
                    onChange={(e) =>
                      setEditData({ ...editData, name: e.target.value })
                    }
                  />
                </div>

                <div>
                  <label>Email</label>
                  <input
                    type="email"
                    value={editData.email}
                    onChange={(e) =>
                      setEditData({ ...editData, email: e.target.value })
                    }
                  />
                </div>

                <div>
                  <label>Mobile Number</label>
                  <input type="text" value={editData.phone} readOnly />
                </div>

                {/* Experience */}
                {/* Experience */}
                <div>
                  <label>Experience Years</label>
                  <input
                    type="text"
                    placeholder="Enter years (example: 2)"
                    value={editData.experience_year || ""}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        experience_year: e.target.value,
                      })
                    }
                  />
                </div>

                <div>
                  <label>Experience Months</label>
                  <input
                    type="text"
                    placeholder="Enter months"
                    value={editData.experience_month || ""}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        experience_month: e.target.value,
                      })
                    }
                  />
                </div>

                <div>
                  <label>Salary</label>
                  <input
                    type="number"
                    value={editData.expected_salary}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        expected_salary: e.target.value,
                      })
                    }
                  />
                </div>

                <div>
                  <label>Location</label>
                  <input
                    type="text"
                    value={editData.location}
                    onChange={(e) =>
                      setEditData({ ...editData, location: e.target.value })
                    }
                  />
                </div>
              </div>

              {/* Skills */}

              <div className="mt-3">
                <label>Skills</label>

                <div className="designer-skill-grid">
                  {skillList.map((skill) => (
                    <div key={skill} className="designer-skill-box">
                      <input
                        type="checkbox"
                        checked={editData.skills?.includes(skill)}
                        onChange={() => {
                          let skills = editData.skills || "";

                          let arr = skills.split(",").map((s) => s.trim());

                          if (arr.includes(skill)) {
                            arr = arr.filter((s) => s !== skill);
                          } else {
                            arr.push(skill);
                          }

                          setEditData({
                            ...editData,
                            skills: arr.join(", "),
                          });
                        }}
                      />

                      <span>{skill}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Description */}

              <div className="mt-3">
                <label>Description</label>

                <textarea
                  value={editData.description}
                  onChange={(e) =>
                    setEditData({ ...editData, description: e.target.value })
                  }
                />
              </div>

              {/* Image */}

              <div className="mt-3">
                <label>Profile Image</label>

                <input
                  type="file"
                  onChange={(e) =>
                    setEditData({
                      ...editData,
                      profile: e.target.files[0],
                    })
                  }
                />
              </div>

              <div className="mt-4 text-end">
                <button
                  className="designer-btn"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Updating..." : "Update Designer"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
